import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator} from "@angular/material/paginator";
import {Ofwca} from "../../../shared/interface/ofwca";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {AnalyticsService} from "../../../shared/services/analytics.service";
import {takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {DictService} from "../../../shared/services/dict.service";

@Component({
  selector: 'app-report-ofwcas',
  templateUrl: './report-ofwcas.component.html',
  styleUrls: ['./report-ofwcas.component.scss']
})
export class ReportOfwcasComponent implements OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private analyticsService: AnalyticsService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private dictService: DictService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.parseFilters();
  }

  ngOnInit(): void {
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      recordId: 'string',
      eq$profitNumber: 'string',
      contains$firstName: 'string',
      contains$secondName: 'string',
      contains$lastName: 'string',
      contains$pesel: 'string',
      contains$documentNumber: 'string',
      contains$email: 'string',
      contains$phone: 'string',
      address: 'string',
      state: 'int',
      assetsRegional: 'string[]',
      lifeRegional: 'string[]',
      partnerAssetsRegional: 'string[]',
      partner: 'string',
      facilityAddress: 'string',
      facilityState: 'int',
      owner: 'int',
      verified: 'int',
      partnerTag: 'int[]',
      rauNumber: 'string',
      status: 'int[]',
      active: 'int',
    }, filters);
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: 10,
      ...this.filtersForm.value,
    })]);
  }
  downloadReport(): void {
    this.analyticsService.downloadReportOfwcas(this.initialFilters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: 10,
    }]);
  }


}
